export default __webpack_public_path__ + "static/media/facilitator_clues.2d3a010a.pdf";